import React from "react"
import { CupomEstabelecimentoFornecedorContextProvider } from "./context/CupomEstabelecimentoFornecedorContextProvider"
import { CupomEstabelecimentoFornecedor } from "./CupomEstabelecimentoFornecedor"

export function Index() {
    return (
        <CupomEstabelecimentoFornecedorContextProvider>
            <CupomEstabelecimentoFornecedor />
        </CupomEstabelecimentoFornecedorContextProvider>
    )
}
